var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"balloon",style:(_vm.$vuetify.breakpoint.smAndDown ? 'right: 10px;' : 'right: 25px'),on:{"click":_vm.handleOpenNewTabWhatsapp}},[_c('v-icon',{attrs:{"color":"white","size":"35"}},[_vm._v("las la-whatsapp")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }